import React from 'react'
import { BetInfo } from '@core/Areas/KambiSports/Components/BetHistory/BetInfo'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { getKambiCouponBetStatus } from '@core/Areas/KambiSports/helpers/getKambiCouponBetStatus'
import {
  KambiHistoryCouponDisplayContext,
  type KambiHistoryCouponDisplayContextType,
} from '@core/Areas/KambiSports/Components/BetHistory/context'
import { BetSelectionContainer } from '../Common/BetSelectionContainer'
import { CashedOutBanner } from './Components/CashedOutBanner'

export const KambiBetSelectionDisplay: React.FC<{
  coupon: BetLoopKambiShareCoupon
  cashedOutAtUtc?: string | null
  handleDisableCopyBet?(): void
  isForExternalShare?: boolean
  ownerAccountDisplayName?: string
  isMySharedBet?: boolean
}> = ({
  coupon,
  cashedOutAtUtc,
  handleDisableCopyBet,
  isForExternalShare = false,
  ownerAccountDisplayName,
  isMySharedBet,
}) => {
  const status = getKambiCouponBetStatus(coupon.bets[0]?.betStatus)
  const betStatus = status === 'Won' ? 'win' : status === 'No Payout' ? 'loss' : null

  const contextValue = React.useMemo<KambiHistoryCouponDisplayContextType>(() => {
    return isForExternalShare
      ? { type: 'external-share', data: { cashedOutAtUtc } }
      : { type: 'betloop', data: { cashedOutAtUtc }, utils: { handleDisableCopyBet } }
  }, [isForExternalShare, cashedOutAtUtc, handleDisableCopyBet])

  return (
    <KambiHistoryCouponDisplayContext.Provider value={contextValue}>
      <BetSelectionContainer.Container displayStatus={betStatus}>
        <BetSelectionContainer.Inner>
          <BetInfo historyCoupon={coupon} />
        </BetSelectionContainer.Inner>
      </BetSelectionContainer.Container>

      {cashedOutAtUtc && ownerAccountDisplayName !== undefined && isMySharedBet !== undefined && (
        <CashedOutBanner
          ownerAccountDisplayName={ownerAccountDisplayName}
          isMySharedBet={isMySharedBet}
        />
      )}
    </KambiHistoryCouponDisplayContext.Provider>
  )
}
